import { getUserFromLocalStorage } from "utils/localStorage";

import type { JobLogEntry } from "./parseJobLogEvent";

import { transientJobUrls } from "../api/urls";
import { emitParsedLogLines, parseJobLogPayload, splitLogStreamLines } from "./parseJobLogEvent";

type ReadJobLogFileParams = {
  errorMessage: string;
  path: string;
  signal?: AbortSignal;
};

const parseJobLogFileText = (text: string): JobLogEntry[] => {
  const trimmed = text.trim();
  if (trimmed.startsWith("[")) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.flatMap((item) => {
          const entry = parseJobLogPayload(item);
          return entry ? [entry] : [];
        });
      }
    } catch {
      /* line-oriented file */
    }
  }
  const entries: JobLogEntry[] = [];
  const { lines, rest } = splitLogStreamLines(`${text}\n`);
  emitParsedLogLines(lines, (line) => entries.push(line));
  if (rest) emitParsedLogLines([rest], (line) => entries.push(line));
  return entries;
};

export const readJobLogFile = async ({ errorMessage, path, signal }: ReadJobLogFileParams) => {
  const user = getUserFromLocalStorage();
  const accessToken = typeof user.access_token === "string" ? user.access_token : "";
  const response = await fetch(transientJobUrls.fileDownload(path), {
    headers: {
      Accept: "text/plain, application/octet-stream, */*",
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
    },
    signal,
  });
  if (!response.ok) throw new Error(errorMessage);
  return parseJobLogFileText(await response.text());
};
